import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-less",
  "use": "icon-less-usage",
  "viewBox": "0 0 63 63",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 63 63\" id=\"icon-less\"><title>less</title><path d=\"M63,31.55C62.45,49.49,49,63,31.34,62.94A31,31,0,0,1,0,32.29c0-.32,0-.63,0-.94C.12,13.48,13.89,0,31.45.06,49.27.07,62.53,13.82,63,31.55Zm-26.62,3.3c2,.06,4.1,0,6.15,0h4.84V28.26c-.82,0-1.53-.09-2.24-.09H15.54v6.68h7.39M34.78,45.19\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol